import React, { useEffect } from 'react';
import { Form, Button, DatePicker, Select, InputNumber } from 'antd';
import { getDisabledDates, formatDate } from 'utils';
import { requiredRule } from 'utils/forms/validationRules';
import { CONTENT_SPAN, LABEL_SPAN } from 'constants/table';
import dayjs from 'dayjs';

const reason = [
  {
    key: 1,
    value: 'п. 1 ст. 57 Трудового Кодекса РК. По инициативе работника',
  },
  {
    key: 2,
    value:
      'п. 1 ст. 51 Трудового Кодекса РК. Расторжение трудового договора по соглашению сторон',
  },
  {
    key: 3,
    value:
      'п. 2 ст. 51 Трудового Кодекса РК. Истечение срока трудового договора',
  },
];

function DismissalForm({ initialValues, disableDate, onSubmit, children }) {
  const [form] = Form.useForm();

  useEffect(() => {
    if (initialValues) {
      const { worker_id, begin_date, contract, reason } = initialValues;

      form.setFieldsValue({
        worker_id,
        begin_date: dayjs(begin_date),
        contract,
        reason,
      });
    }
  }, [initialValues]);

  const handleSubmit = async (values) => {
    const payload = {
      ...values,
      begin_date: formatDate(values?.begin_date, 'YYYY-MM-DD'),
    };

    const isSubmitted = await onSubmit(payload);

    if (isSubmitted) {
      form.resetFields();
    }
  };

  return (
    <Form
      form={form}
      onFinish={handleSubmit}
      layout="horizontal"
      labelCol={{
        span: LABEL_SPAN,
      }}
      wrapperCol={{ span: CONTENT_SPAN }}
      labelAlign="right"
    >
      {children}

      <Form.Item
        name="begin_date"
        label="Дата увольнения"
        rules={[requiredRule]}
      >
        <DatePicker
          allowClear
          format="DD.MM.YYYY"
          disabledDate={getDisabledDates(disableDate)}
          style={{ width: '100%' }}
        />
      </Form.Item>

      <Form.Item name="reason" label="Статья" rules={[requiredRule]}>
        <Select allowClear placeholder="Выбрать статью">
          {reason.map(({ key, value }) => (
            <Select.Option key={key} value={value}>
              {value}
            </Select.Option>
          ))}
        </Select>
      </Form.Item>

      <Form.Item name="contract" label="Номер договора">
        <InputNumber
          addonAfter="№"
          controls={false}
          placeholder="Введите номер договора"
          style={{ width: '100%' }}
        />
      </Form.Item>

      <Form.Item wrapperCol={{ offset: CONTENT_SPAN }}>
        <Button type="primary" htmlType="submit">
          Сохранить
        </Button>
      </Form.Item>
    </Form>
  );
}

export { DismissalForm };
